export const getDisabled = (questionData, last, hasAnswer) => {
  if (questionData?.questionType === 1) { // 单选
    const chosen = questionData.memberAnswerList.filter(item => item.memberOptionSelected === 1);
    const childAnswerList = chosen?.[0]?.childAnswerList || [];
    let flag = childAnswerList?.length !== 0;
    childAnswerList.some(item => {
      if (item.answerType === 1) {  // 1：必填
        flag = !(item?.memberOptionContent || item?.memberAnswerPicList?.length)
        if (flag) {
          flag = item;
          return item;
        }
      } else {
        flag = false;
      }
    });
    let result = !questionData?.value || flag;
    if (last && questionData.answerType === 2) {// 最后一题是选填的（给提交用）
      result = hasAnswer ? flag : !(chosen?.length > 0 && !flag)
    }
    return result;
  } else if (questionData?.questionType === 2) { // 多选
    const answerList = questionData.memberAnswerList.filter(item => item.memberOptionSelected === 1) || [];
    const childAnswerList = [];
    answerList.map(item => {
      if (item?.childAnswerList?.length) {
        childAnswerList.push(...item.childAnswerList)
      }
    })
    let flag = childAnswerList?.length !== 0;
    childAnswerList?.some(item => {
      if (item.answerType === 1) {  // 1：必填
        flag = !(item?.memberOptionContent || item?.memberAnswerPicList?.length)
        if (flag) {
          flag = item;
          return item;
        }
      } else {
        flag = false;
      }
    });
    
    let result = flag;
    if (questionData.answerType === 1) {
      result = answerList?.length === 0 || flag;
    } else if (last && questionData.answerType === 2) { // 最后一题是选填的（给提交用）
      result = hasAnswer ? flag : !(answerList?.length > 0 && !flag);
    }
    return result;
  } else if (questionData?.questionType === 3) { // 问答
    let flag = true;
    questionData?.memberAnswerList?.forEach(item => {
      if (item?.memberOptionContent || item?.memberAnswerPicList?.length) {
        flag = false;
      }
    });
    return questionData.answerType === 1 ? flag : false;
  }
  return true;
};

import { ref } from '@vue/composition-api';
export const skipToDefault = ref(false);

import { isCottiApp } from '@/utils/index';
export const highVersion = (() => {
  if (isCottiApp) {
    const userAgent = navigator.userAgent.split('/')
    if (userAgent[0]=='cottiCoffee' && Number(userAgent[1]) >= 207) {
      return true;
    } else if (userAgent[0]=='teacat' && Number(userAgent[1]) >= 202) {
      return true;
    }
  }
  return false;
})

export const getTip = (questionData) => {
  if (questionData.questionType === 3) {
    return '请填写内容';
  } else {
    const chosen = questionData.memberAnswerList.filter(item => item.memberOptionSelected === 1);
    if (chosen.length) {
      if (getDisabled(questionData)) {
        return '请填写内容';
      }
    } else {
      return '请选择问题选项';
    }
  }
}